export default {"src":"/_next/static/media/sports7.b94092cc.svg","height":72,"width":72,"blurWidth":0,"blurHeight":0};